import React, { useEffect, useState } from 'react';

// components
import { Button, Card, CardBody, CardHeader, Row, Col, Spinner, Nav, NavItem, NavLink } from "reactstrap";

// views
import FormularioFichaIdentificacao from './Components/Identificacao';
import FormularioFichaCabecalho from './Components/Cabecalho';
import FormularioFichaQuestoes from './Components/Questoes';
import FormularioFichaModalPreVisualizacao from './Components/ModalPreVisualizacao';

// api
import usuario_api from "../../../api/usuario_api.js";

export default function FormularioFicha({ item, handleReturn }) {

    const [showLoading, setshowLoading] = useState(false);
    const [isDisable, set_isDisable] = useState(true);

    const [stepFormulario, set_stepFormulario] = useState(0);
    const handleStepFormulario = (step) => {
        if (step > 0 && formularioVistoria == null)
            return;

        set_stepFormulario(step);
    }

    const [isOpenModalPreVisualizacao, set_isOpenModalPreVisualizacao] = useState(false);

    const [formularioVistoria, set_formularioVistoria] = useState(item);

    const Voltar = () => {
        handleReturn();
    }

    useEffect(() => {
        usuario_api.getFuncionalidadeAcaoLiberada("CadastroFormularios", "Editar").then((result) => { set_isDisable(!result); });
    }, []);

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <Row>
                    <Col md="6">
                        <Button color="default" onClick={Voltar}><i className="fas fa-chevron-left"></i>  Voltar</Button>
                    </Col>
                    <Col md="6" className="text-right">
                        <Button color="info" onClick={() => set_isOpenModalPreVisualizacao(true)}><i className="fas fa-file"></i>  Pré-Visualização</Button>
                    </Col>
                    <Col md="12">
                        <Card>
                            <CardHeader>
                                <h4 className="titleCard">Formulário de Vistoria</h4>
                                <Nav justified tabs pills className="mr-auto">
                                    <NavItem>
                                        <NavLink active={stepFormulario == 0} onClick={() => handleStepFormulario(0)}>Identificação</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink active={stepFormulario == 1} onClick={() => handleStepFormulario(1)}>Cabeçalho</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink active={stepFormulario == 2} onClick={() => handleStepFormulario(2)}>Questões</NavLink>
                                    </NavItem>
                                </Nav>
                            </CardHeader>
                            <CardBody>
                                {stepFormulario == 0 && <FormularioFichaIdentificacao
                                    formularioVistoria={formularioVistoria}
                                    sDisable={isDisable}
                                    update={set_formularioVistoria}
                                    setshowLoading={setshowLoading}
                                />
                                }
                                {stepFormulario == 1 && <FormularioFichaCabecalho
                                    formularioVistoria={formularioVistoria}
                                    isDisable={isDisable}
                                    update={set_formularioVistoria}
                                    setshowLoading={setshowLoading}
                                />
                                }
                                {stepFormulario == 2 && <FormularioFichaQuestoes
                                    formularioVistoria={formularioVistoria}
                                    isDisable={isDisable}
                                    update={set_formularioVistoria}
                                    setshowLoading={setshowLoading}
                                />
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            {formularioVistoria && <FormularioFichaModalPreVisualizacao
                isOpen={isOpenModalPreVisualizacao}
                formularioVistoria={formularioVistoria}
                handleReturn={() => set_isOpenModalPreVisualizacao(false)} />
            }
        </>
    );
}

